// extracted by mini-css-extract-plugin
export default {"commit-message-container":"CommitHeader-module__commit-message-container--nl1pf","commit-header-actions":"CommitHeader-module__commit-header-actions--kHXV1"};